// src/features/dashboard/hooks/useDashboardData.js
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchCardData,
  fetchBuCount,
  fetchUserInteraction,
  fetchWeeklyUsers,
  fetchQuestionDist,
  fetchFeedbackCount,
  fetchFeedbackDist,
  fetchUniqueUsersList,
  fetchAgentMap 
} from "../../../redux/slices/dashboardSlice";

// ── Period → data_basis mapping ───────────────────────────────
export const PERIOD_TO_DATA_BASIS = {
  lastMonth: "MONTHLY",
  last24hrs: "DAILY",
  lastYear: "YEARLY",
  lastWeek: "WEEKLY",
};

const buildPayload = (filters) => {
  const {
    subAgentName,
    businessUnit,
    userGroup,
    period,
    startDate,
    endDate,
    selectedEmails,
  } = filters;

  const basePayload = {
    sub_agent_name: subAgentName,
    business_unit: businessUnit,
    user_group: userGroup,
    user_email_list: selectedEmails,
  };

  // Predefined period (lastWeek, lastMonth etc.)
  if (PERIOD_TO_DATA_BASIS[period]) {
    return {
      ...basePayload,
      start_date: null,
      end_date: null,
      data_basis: PERIOD_TO_DATA_BASIS[period],
    };
  }

  // Custom date range
  return {
    ...basePayload,
    start_date: startDate,
    end_date: endDate,
  };
};

// ── Hook ──────────────────────────────────────────────────────
const useDashboardData = () => {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.filters);


    const fetchMetadata = useCallback(() => {
    dispatch(fetchAgentMap());
  }, [dispatch]);

  const fetchAllData = useCallback(() => {
    const payload = buildPayload(filters);

    dispatch(fetchCardData(payload));
    dispatch(fetchBuCount(payload));
    dispatch(fetchUserInteraction(payload));
    dispatch(fetchWeeklyUsers(payload));
    dispatch(fetchQuestionDist(payload));
    dispatch(fetchFeedbackCount(payload));
    dispatch(fetchFeedbackDist(payload));
    dispatch(fetchUniqueUsersList(payload));
  }, [dispatch, filters]);

  return { fetchAllData ,fetchMetadata };
};

export default useDashboardData;
